// Two files can produce the same name (same day, category and remark); a zip
// entry name must be unique or one file silently replaces the other. A suffix
// can itself collide with another file's real name ("x", "x", "x-2"), so keep
// counting until the name is free.
export const uniqueNames = names => {
  const used = new Set();
  return names.map(name => {
    let candidate = name;
    const dot = name.lastIndexOf(".");
    for (let n = 2; used.has(candidate); n++) {
      candidate =
        dot > 0 ? `${name.slice(0, dot)}-${n}${name.slice(dot)}` : `${name}-${n}`;
    }
    used.add(candidate);
    return candidate;
  });
};
